import { CANONICAL_SERVICE_CODE } from "@/shared/mention/constants";

function localizedPart(addr, base, kz) {
  if (kz && addr[`${base}_kk`]) return addr[`${base}_kk`];
  return addr[base] || "";
}

export function assembleEntityAddress(entityAddress, kz = false) {
  const a = entityAddress;
  if (!a || typeof a !== "object") return "";
  return [
    localizedPart(a, "region", kz),
    localizedPart(a, "district", kz),
    localizedPart(a, "city", kz),
    localizedPart(a, "street", kz),
    a.building,
    a.corpus,
    a.flat,
  ]
    .filter(Boolean)
    .join(", ");
}

export function buildCanonicalFields(payload, { participantTypeCode } = {}) {
  if (!payload || typeof payload !== "object" || !participantTypeCode) {
    return [];
  }

  const out = [];

  if (payload.identifier) {
    out.push({
      key: "identifier",
      value: payload.identifier,
      participant_type_code: participantTypeCode,
      service_code: CANONICAL_SERVICE_CODE,
    });
  }

  const addLocalized = (key, ru, kz) => {
    const rv = ru || "";
    const kv = kz || rv;
    if (!rv && !kv) return;
    out.push({
      key,
      value: rv || kv,
      participant_type_code: participantTypeCode,
      service_code: CANONICAL_SERVICE_CODE,
      localizedValues: { ru: rv || kv, kz: kv },
    });
  };

  addLocalized("display_name", payload.display_name, payload.display_name_kk);

  // Адрес целиком (для обратной совместимости со старыми шаблонами)
  addLocalized(
    "entity_address",
    assembleEntityAddress(payload.entity_address, false),
    assembleEntityAddress(payload.entity_address, true)
  );

  // Части адреса «как приходит»: каждый подключ entity_address_<subKey>
  // (включая *_kk) — отдельный канон-ключ. UI показывает их 1:1.
  const addr = payload.entity_address;
  if (addr && typeof addr === "object") {
    Object.entries(addr).forEach(([subKey, val]) => {
      const v = val == null ? "" : String(val);
      if (!v) return;
      out.push({
        key: `entity_address_${subKey}`,
        value: v,
        participant_type_code: participantTypeCode,
        service_code: CANONICAL_SERVICE_CODE,
      });
    });
  }

  return out;
}
